<template>
  <div>
    <div class="head">
      <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/processManager/safety'}">安全制度</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.params.key ? '修订' : '新增' }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <el-form :model="form" label-width="350px" :rules="rules" class="demo-ruleForm" style="width:100%;margin: auto auto">
        <el-form-item prop="region" label="名称：">
          <el-input :disabled="isDisabled" v-model="form.safeName" id="remainder" size="small" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item prop="region" label="类型：">
          <el-select :disabled="isDisabled" v-model="form.safeType" placeholder="请选择…" clearable size="small"  style="width: 300px">
            <el-option v-for="item in arr2" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文件上传"  prop="region">
          <el-upload :disabled="isDisabled" class="upload-demo" drag action="/v1/safety/uploadFile" :on-change="handleChange"
          :file-list="fileList" :on-remove="fileRemove">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item prop="region" label="计划修订时间" >
          <el-date-picker :disabled="isDisabled"
            v-model="form.reviseTime"
            type="date"
            placeholder="选择日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="region" label="发布人" >
          <Select :disabled="isDisabled" v-model="form.publishId" placeholder="请添加" style="width:500px">
            <Option
              v-for="item in userData"
              :key="item.id"
              :label="item.nickname"
              :value="item.id"
            ></Option>
          </Select>
        </el-form-item>
        <el-form-item prop="region" label="是否需要评审">
          <el-radio-group :disabled="isDisabled" v-model="form.isDel" size="small">
            <el-radio-button label="0">不需要</el-radio-button>
            <el-radio-button label="1">需要</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="region" v-if="form.isDel == 1" label="评审人">
          <Select :disabled="!isAdd" v-model="form.companyId" placeholder="请添加" style="width:500px">
            <Option
              v-for="item in userData"
              :key="item.id"
              :label="item.nickname"
              :value="item.id"
            ></Option>
          </Select>
        </el-form-item>
        <el-form-item prop="" v-if="form.isDel == 1" label="流程模板" v-show="isAdd">
          <Select :disabled="!isAdd" v-model="form.definitionId"
           placeholder="请添加" style="width:500px" @on-change="modelChange">
            <Option
              v-for="m in modules"
              :key="m.id"
              :label="m.name"
              :value="m.definitionId"
            ></Option>
          </Select>
        </el-form-item>
      </el-form>
      <div>
        <el-button v-if="opStatus == 0" type="primary" class="addBtn" @click="submitForm()">确定</el-button>
        <el-button v-if="opStatus == 2" type="primary" class="addBtn" @click="submitForm(1)">确认修订</el-button>
        <el-button v-if="opStatus == 1" type="primary" class="addBtn" @click="submitCheck(4)" >同意</el-button>
        <el-button v-if="opStatus == 1" type="danger" class="addBtn" @click="submitCheck(5)" style="margin-top: 5%;">驳回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { modulesList } from "@/api/model.js"
  export default {
    data() {
      return {
        isDisabled:false,
        isAdd:true,
        dialogVisible: false,
        form: {
          isDel:0
        },
        rules: {
          name: [{required: true, message: "请输入名称", trigger: "blur"}],
        },
        options: [],
        getObj: {},
        isShowBtn: true,
        isShowBtn2: true,
        emergeData: [],
        emergeData2: [],
        fileList: [],
        type:0,
        status:1,
        opStatus:0,
        arr: [
          {label: "编制中", value: 0},
          {label: "评审中", value: 1},
          {label: "使用中", value: 2},
          {label: "已作废", value: 3},
        ],
        arr2: [
          {label: "规章制度", value: 0},
          {label: "操作规程", value: 1},
          {label: "检查表", value: 2},
        ],
        userData:[],
        modules: []
      };
    },
    mounted(){
      this.getUserData();
      this.getModulesList()
    },
    methods: {
      handleChange(file, fileList) {
        this.fileList = fileList.slice(-3);
      },
      // 文件列表移除文件的函数
      fileRemove(file, fileList) {
        let arr = this.fileList
        for(let i in arr){
          if(arr[i].name === file.name){
            arr.splice(i,1)
          }
        }
        this.fileList = arr
      },
      // 获取模板列表
      getModulesList() {
        modulesList().then(res => {
          this.modules = res.body.data
        }) 
      },
      // 模板更改
      modelChange(a) {
        let obj = {}
        obj = this.modules.find(v => {
          return a === v.definitionId
        })
        this.form.key = obj.key
        // console.log(this.form)
      },
      getUserData(){
        this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData("urls").getAllUser)
        .openLoad()
        .startGet()
        .then((res) => {
          this.userData = res.body.data;
        });
      },
      submitCheck(status){
        let formData = new FormData();
        formData.append("id",this.form.id);
        formData.append("status",status);
        this.componentsMoudel.httpRequest
          .getRequestHander("/safety/submitCheck")
          .openLoad()
          .startPost(formData)
          .then((res) => {
            this.$message({
              showClose: true,
              message: "操作成功",
              type: "success",
            });
            this.$router.push({
              path: "/processManager/safety",
            });
          });
        },
        submitForm(status) {
          let url = "";
          if (this.isAdd){
            url = "/safety/save"
          } else{
            url = "/safety/update"
          }
          if(this.fileList.length > 0) {
            this.form.safeFileName = this.fileList[0].name;
            this.form.safeUrl = this.fileList[0].response.data;
          }
          if (status){
            this.form.safeStatus = status;
          } else{
            this.form.safeStatus = 0;
          }
          if (this.form.isDel == 0){
            this.form.safeStatus = 2;
          }
          // this.form.safeType = this.type;
          this.componentsMoudel.httpRequest
            .getRequestHander(url)
            .openLoad()
            .startPost(this.form)
            .then((res) => {
              this.$message({
                showClose: true,
                message: "添加成功",
                type: "success",
              });
              this.$router.push({
                path: "/processManager/safety",
              });
            });
        },
    },
    created() {
      let obj = this.$route.params.key;
      if (this.$route.params.key) {
        this.opStatus = this.$route.params.status;
        if (this.opStatus == 1){
          this.isDisabled = true;
        }
        this.form = obj;
        this.isAdd = false;
        if(obj.safeUrl !== 'null' && obj.safeUrl !== '' && obj.safeUrl !== null) {
          let file = {response:{} };
          file.response.data = obj.safeUrl;
          file.name = obj.safeFileName;
          this.fileList.push(file);
        }
        this.status=this.form.safeStatus;
        this.type = this.form.safeType;
      } else {
        this.isAdd = true;
        this.ruleForm = {};
      }
    },
  };
</script>

<style scoped>
  .addBtn {
    display: block;
    width: 300px;
    margin: 0 auto;
  }
  .el-divider__text {
    font-size: 20px !important;
  }
</style>
